import { render } from "./UserEvents.vue?vue&type=template&id=24f216d4&scoped=true&ts=true"
import script from "./UserEvents.vue?vue&type=script&lang=ts"
export * from "./UserEvents.vue?vue&type=script&lang=ts"

import "./UserEvents.vue?vue&type=style&index=0&id=24f216d4&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f216d4"]])

export default __exports__